<div class="tab-leaderboard bottom-spacer">
  <div class="tab-leaderboard__column">
    @if (casualTournamentDetails && leaders && leaders.length > 0) {}
    <p class="mat-body-3 info-winner">
      The winner is the
      {{ casualTournamentDetails?.game?.highScoreWins ? 'highest' : 'lowest' }}
      score.{{
        showScores
          ? ''
          : ' The scores are pending final validation at the end of the tournament.'
      }}
    </p>
    <div class="bottom-spacer">
      <fz-shared-table-component
        [configuration]="configuration"
        [isLoggedIn]="isLoggedIn"
        [loading]="loading"
        [currentUser]="user"
        (pageChanged)="onLeaderboardPageChange($event)"
        (loginButtonPressed)="onLogin()"
        [displayedColumns]="displayedColumns"
        [dataSource]="leaders"
      ></fz-shared-table-component>
    </div>
    <ng-container *ngTemplateOutlet="playControls"></ng-container>
  </div>
  <div class="column tab-leaderboard__column summary">
    <fz-score-summary
      [eventCode]="eventCode"
      [showSummary]="user?.user !== null && user?.user !== undefined"
      [bestScore]="bestScores"
      [seats]="seats"
      [isLEP]="isLEP"
      [prizeImage]="prizeImage"
      [prizeValue]="prizeValue"
      [entryAmount]="entryAmount"
      [eventScheduleDetails]="eventSchedule"
      [metadata]="casualTournamentDetails?.metadata"
    ></fz-score-summary>
  </div>
</div>
